import { LOGIN, LOGIN_WITH_API, LOGOUT } from './navigator/links';
import LoginPage from './pages/login';
import LoginWithIdpPage from 'pages/login/LoginWithIdpPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import RootNavigator from './navigator/root';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import LogoutPage from 'pages/logout';

function App(): JSX.Element {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#12284C',
      },
      secondary: {
        main: '#fea71d',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter basename={import.meta.env.VITE_APP_BASE_PATH}>
        <Routes>
          <Route path={LOGIN_WITH_API} element={<LoginWithIdpPage />} />
          <Route path={LOGIN} element={<LoginPage />} />
          <Route path={LOGOUT} element={<LogoutPage />} />
          <Route path='*' element={<RootNavigator />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
